import { motion } from "framer-motion";
import { Sparkles, RefreshCw } from "lucide-react";
import microsoftIcon from "@/assets/ms-icons/microsoft.svg";

const MigrationOrigins = () => {
  return (
    <section className="bg-muted/40 py-16 md:py-24">
      <div className="container">
        <motion.div
          className="text-center mb-12"
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <h2 className="text-2xl font-bold md:text-3xl">
            Waar kom je{" "}
            <span className="text-gradient">vandaan?</span>
          </h2>
          <p className="mt-3 text-lg text-muted-foreground">
            Of je nu helemaal opnieuw begint, al Microsoft 365 hebt of van Google Workspace komt — wij regelen het.
          </p>
        </motion.div>

        <div className="mx-auto grid max-w-5xl gap-6 md:grid-cols-3">
          {/* Nieuw begin */}
          <motion.div
            className="rounded-xl border border-border bg-card p-6 shadow-card hover:shadow-card-hover transition-shadow"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0 }}
          >
            <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-hero-gradient text-primary-foreground mb-4">
              <Sparkles className="h-6 w-6" />
            </div>
            <h3 className="text-lg font-semibold">Helemaal nieuw beginnen</h3>
            <p className="mt-2 text-sm leading-relaxed text-muted-foreground">
              Nog geen Microsoft 365? Wij zetten alles voor je op. Van e-mail tot opslag, van beveiliging tot apparaatbeheer. 
              Jij hoeft alleen maar in te loggen — de rest doen wij.
            </p>
          </motion.div>

          {/* Al Microsoft 365 */}
          <motion.div
            className="rounded-xl border border-border bg-card p-6 shadow-card hover:shadow-card-hover transition-shadow"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.08 }}
          >
            <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-white border border-border mb-4 p-2">
              <img loading="lazy" decoding="async" src={microsoftIcon} alt="Microsoft 365" className="h-7 w-7 object-contain" />
            </div>
            <h3 className="text-lg font-semibold">Al Microsoft 365?</h3>
            <p className="mt-2 text-sm leading-relaxed text-muted-foreground">
              We nemen het beheer over van je huidige partij. Met speciale software brengen we je omgeving naar de laatste standaarden — 
              en houden het daarna ook zo. Jij merkt er weinig van, behalve dat alles beter en veiliger wordt.
            </p>
          </motion.div>

          {/* Google Workspace */}
          <motion.div
            className="rounded-xl border border-border bg-card p-6 shadow-card hover:shadow-card-hover transition-shadow"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.16 }}
          >
            <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-white border border-border mb-4 p-2">
              <svg viewBox="0 0 24 24" className="h-7 w-7" xmlns="http://www.w3.org/2000/svg">
                <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1z" fill="#4285F4"/>
                <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
                <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/>
                <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
              </svg>
            </div>
            <h3 className="text-lg font-semibold">Van Google Workspace?</h3>
            <p className="mt-2 text-sm leading-relaxed text-muted-foreground">
              We verhuizen alles op de achtergrond naar Microsoft 365. E-mails, agenda's, bestanden — het gaat vanzelf. 
              Jullie werken gewoon door terwijl wij de boel overzetten. Dit hebben we al vaak gedaan.
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default MigrationOrigins;
